import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ECURemapping from "./pages/ECURemapping";
import Programming from "./pages/Programming";
import Diagnostic from "./pages/Diagnostic";
import CarService from "./pages/CarService";
import Recovery from "./pages/Recovery";
// import PartWornTyres from "./pages/PartWornTyres";
// import SummerTyres from "./pages/SummerTyres";
// import WinterTyres from "./pages/WinterTyres";
// import PremiumTyres from "./pages/PremiumTyres";
// import AllSeasonTyres from "./pages/AllSeasonTyres";

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/ecu-remapping" element={<ECURemapping />} />
        <Route path="/programming" element={<Programming />} />
        <Route path="/diagnostic" element={<Diagnostic />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/car-service" element={<CarService />} />
        {/* <Route path="/pwt" element={<PartWornTyres />} />
        <Route path="/summer" element={<SummerTyres />} />
        <Route path="/winter" element={<WinterTyres />} />
        <Route path="/premium" element={<PremiumTyres />} />
        <Route path="/allseason" element={<AllSeasonTyres />} /> */}
      </Routes>
    </div>
  );
}

export default App;
